import React, { useState, useEffect, useContext } from "react";
import { getCurrentDate } from "../../../configs/helpers";
import { ReceiveOrderPurchaseList } from "../fragments.buys/ReceiveOrderPurchaseList";
import { ReceiveOrderPurchaseForm } from "../fragments.buys/ReceiveOrderPurchaseForm";

import { useParams } from "react-router";
import { fetchedOrderPurchaseByID } from "../../../apis/apis.logistics/apisProduct";
import { initialOrderState } from "../../../configs/OrderPurchaseStates";

export function ReceiveOrderPurchasePage() {
    let { id } = useParams();
    const [order, setOrder] = useState(initialOrderState);
    const [loading, setLoading] = useState(true);

    const getOrderPurchase = async () => {
        try {
            setLoading(true);
            const response = await fetchedOrderPurchaseByID({
                operationID: id,
            });

            const transformedOrder = {
                ...initialOrderState,
                ...response,
                operationID: response.operationID || parseInt(id),
                operationDate: getCurrentDate("-"),
                operationDocumentNumber: response.operationDocumentNumber || "",
                code: response.code || "",
                percentageIgv: response.percentageIgv || 18,
                conditionIgv: response.conditionIgv || "01",
                supplierDocumentType: response.supplierDocumentType || "06",
                supplierDocumentNumber: response.supplierDocumentNumber || "",
                supplierName: response.supplierName || "",
                supplierFiscalAddress: response.supplierFiscalAddress || "",
                supplierID: response.supplierID || 0,
                warehouseID: 0,
                userID: response.userID || 0,
                operationItems: response.operationItems.map((item) => {
                    const ordered = Number(item.quantityOrdered) || 0;
                    const received = Number(item.quantityReceived) || 0;
                    const missing = ordered - received;
                    const shouldReceive = missing > 0;

                    return {
                        ...item,
                        quantity: shouldReceive ? missing : 0,
                        condition: shouldReceive
                            ? "02"
                            : received >= ordered
                              ? "03"
                              : "01",
                        price: item.priceDisplay || item.price || 0,
                        amountIgv: item.amountIgv || item.totalWithIgv || 0,
                    };
                }),
            };
            setOrder(transformedOrder);
        } catch (error) {
            console.error("Error al cargar orden:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getOrderPurchase();
    }, [id]);

    if (loading) {
        return (
            <div className="flex items-center justify-center py-20">
                <div className="h-10 w-10 rounded-full border-4 border-gray-300 border-t-blue-600 animate-spin"></div>
            </div>
        );
    }

    return (
        <div className="fade-in">
            <div className="max-w-full px-4">
                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                        Ordenes de Compra: Recepción #
                        {order.code || order.operationID}
                    </h1>
                </div>

                <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-6">
                    <ReceiveOrderPurchaseForm
                        order={order}
                        setOrder={setOrder}
                    />
                    <ReceiveOrderPurchaseList
                        order={order}
                        setOrder={setOrder}
                        initialOrderState={initialOrderState}
                    />
                </div>
            </div>
        </div>
    );
}
